import * as React from 'react'
import { ImageWidget } from './ImageWidget'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ImageWidgetExamples = () => {
  return (
    <div className="ImageWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ImageWidget />
      </Provider>
    </div>
  )
}
